import { useState, useEffect, useRef } from 'react';

const GHL_BOOKING_URL = 'https://api.leadconnectorhq.com/widget/booking/BbTNQ40bgtpSYcpM0mTG';
const IFRAME_ID = 'BbTNQ40bgtpSYcpM0mTG_1775569421739';

export default function BookingModal() {
  const [open, setOpen] = useState(false);
  const [iframeHeight, setIframeHeight] = useState(700);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('openBooking', handler);
    return () => window.removeEventListener('openBooking', handler);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  // Listen for height messages from GHL iframe
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (!e.data) return;
      // GHL sends { type: 'iframeHeight', value: number } or similar
      try {
        const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
        if (data?.type === 'iframeHeight' && typeof data.value === 'number') {
          setIframeHeight(Math.max(600, data.value + 40));
        }
        // Some GHL versions send height directly as a number
        if (typeof data === 'number' && data > 200) {
          setIframeHeight(Math.max(600, data + 40));
        }
      } catch {
        // ignore parse errors
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  const close = () => setOpen(false);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-0 sm:p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={close} />

      {/* Modal shell */}
      <div
        className="relative bg-white w-full sm:max-w-2xl sm:rounded-2xl flex flex-col"
        style={{ height: '95vh', maxHeight: '95vh' }}
      >
        {/* Header — fixed at top */}
        <div className="bg-[#145A32] px-5 py-4 flex items-center justify-between flex-shrink-0 sm:rounded-t-2xl">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/10 flex-shrink-0">
              <i className="ri-calendar-check-line text-[#7AC943] text-lg" />
            </div>
            <div>
              <div className="text-white font-black text-base">Book an Appointment</div>
              <div className="text-white/55 text-xs">Mon–Sat · London, Essex, Suffolk &amp; Cambridge</div>
            </div>
          </div>
          <button
            onClick={close}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-xl" />
          </button>
        </div>

        {/* Scrollable iframe container */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden bg-white sm:rounded-b-2xl">
          <iframe
            ref={iframeRef}
            id={IFRAME_ID}
            src={GHL_BOOKING_URL}
            title="Book an Appointment"
            style={{
              width: '100%',
              height: `${iframeHeight}px`,
              border: 'none',
              display: 'block',
            }}
            scrolling="yes"
          />
        </div>
      </div>
    </div>
  );
}